import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, Observer, Subject } from 'rxjs';
import { ApiService } from '../services/api.service';
import { ApiServiceDelegate } from '../models/api-service-delegate';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ApiCollection } from '../providers/api-collection';
import {
  VenueResponseModel,
  CityResponseModel,
  CountryResponseModel,
  StateResponseModel,
  UserResponseModel,
  VenueTypeResponseModel,
  VenuePocResponseModel,
  VenueRoomResponseModel,
  VenueInformationResponseModel,
} from '../models/venue.model';
import { VendorListResponseModel,VenueModel,mapVenueResponseToModel } from '../models/venue.model';
import { VenueDrawerComponent } from '../components/venue-drawer/venue-drawer.component';
import { VenuesComponent } from '../pages/venues/venues.component';
import { VenueAddPocComponent } from '../components/venue-add-poc/venue-add-poc.component';
import { CountryCodeResponseModel } from '../models/client.model';
import { VenueDetailComponent } from './../pages/venues/venue-detail/venue-detail.component';
import { VenueAddRoomComponent } from './../components/venue-add-room/venue-add-room.component';

@Injectable({
  providedIn: 'root',
})
export class VenueViewModel {
  venueDrawerComponent: VenueDrawerComponent;
  parentVenuesComponent: VenuesComponent;
  parntVenuesPocComponet: VenueDetailComponent; // to fetch venue poc data
  parntVenuesRoomComponet: VenueDetailComponent; // to fetch venue room data
  VenueAddPocComponent: VenueAddPocComponent;
  VenueAddRoomComponent: VenueAddRoomComponent;
  VenueDetailComponent: VenueDetailComponent;

  userList = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
  venueResponseModel = new BehaviorSubject<VenueResponseModel>(
    new VenueResponseModel()
  );
  cityList = new BehaviorSubject<CityResponseModel>(new CityResponseModel());
  venueTypeList = new BehaviorSubject<VenueTypeResponseModel>(
    new VenueTypeResponseModel()
  );
  vendorList = new BehaviorSubject<VendorListResponseModel>(
    new VendorListResponseModel()
  );

  venuePocResponseModel = new BehaviorSubject<VenuePocResponseModel>(
    new VenuePocResponseModel()
  );

  venueRoomResponseModel = new BehaviorSubject<VenueRoomResponseModel>(
    new VenueRoomResponseModel()
  );

  venueInformationResponseModel =
    new BehaviorSubject<VenueInformationResponseModel>(
      new VenueInformationResponseModel()
    );

  subscribeToVenuePocList(observer: Observer<VenuePocResponseModel>) {
    this.venuePocResponseModel.subscribe(observer);
  }

  subscribeToVenueRoomList(observer: Observer<VenueRoomResponseModel>) {
    this.venueRoomResponseModel.subscribe(observer);
  }

  subscribeToVenueInformationList(
    observer: Observer<VenueInformationResponseModel>
  ) {
    this.venueRoomResponseModel.subscribe(observer);
  }

  outsourcingRequestVenueDetailModel = new BehaviorSubject<VenueModel>(
    new VenueModel()
  );


  subscribeToVenueDetails(observer: Observer<VenueModel>) {
    this.outsourcingRequestVenueDetailModel.subscribe(observer);
  }

  countryCodeList = new BehaviorSubject<CountryCodeResponseModel>(
    new CountryCodeResponseModel()
  );

  linkResponse = new Subject();
  roomMediaLinks = new Subject();

  constructor(
    private apiService: ApiService,
    private message: NzMessageService
  ) {}

  subscribeToVenues(observer: Observer<VenueResponseModel>) {
    this.venueResponseModel.subscribe(observer);
  }

  private formatBackendErrors(errors: any): void {
    let errorMessages = '';
    if (typeof errors === 'object') {
      for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
          errorMessages += `<strong>${key}:</strong> ${
            Array.isArray(errors[key]) ? errors[key].join(', ') : errors[key]
          }<br>`;
        }
      }
    } else {
      errorMessages = errors.toString();
    }
    this.message.error(errorMessages, { nzDuration: 1000 });
  }

    getOutsourcingRequestVenueDetails(id: any) {
    let str = ApiCollection.venue + '/' + id;

    let d: ApiServiceDelegate = {
       Data: {},
      Method: 'GET',
      Action: str,
      Success: (e: any) => {
        // this.outsourcingRequestVenueDetailModel.next(e);
        this.outsourcingRequestVenueDetailModel.next(mapVenueResponseToModel(e));
        this.VenueDetailComponent.outsourcingRequestVenueDetailsRecieved();
        return e;
      },
      Error: (e: String) => {
        return e;
      },
    };
     this.apiService.callService(d);
  }


  getUserList(page: number, page_size: number) {
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: ApiCollection.User + '?page=' + page + '&page_size=' + page_size + '&is_deleted=false',
      Success: (e: any) => {
        this.userList.next(e);
        return e;
      },
      Error: (e: String) => {
        return e;
      },
    };
    this.apiService.callService(d);
  }

  getVenueTypeList() {
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: ApiCollection.venueType + '?page=1&page_size=100',
      Success: (e: any) => {
        this.venueTypeList.next(e);
        return e;
      },
      Error: (e: String) => {
        return e;
      },
    };
    this.apiService.callService(d);
  }
  subscribeToVenueTypes(observer: Observer<VenueTypeResponseModel>) {
    this.venueTypeList.subscribe(observer);
  }

  getVendorList() {
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: ApiCollection.Vendor + '?page=1&page_size=1000',
      Success: (e: any) => {
        this.vendorList.next(e);
        return e;
      },
      Error: (e: String) => {
        return e;
      },
    };
    this.apiService.callService(d);
  }
  subscribeToVendorsList(observer: Observer<VendorListResponseModel>) {
    this.vendorList.subscribe(observer);
  }

  getCityListById(page: number, page_size: number, id?: number, name?: string) {
    let url = ApiCollection.City + '?page=' + page + '&page_size=' + page_size;
    if (id) {
      url += '&state=' + id;
    }
    if (name) {
      url += '&name=' + name;
    }
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: url,
      Success: (e: any) => {
        this.cityList.next(e);
        return e;
      },
      Error: (e: String) => {
        return e;
      },
    };
    this.apiService.callService(d);
  }

  getVenues(page: number, page_size: number, search: string, filters: any = {}) {
    let url = ApiCollection.venue + '?page=' + page + '&page_size=' + page_size;
    if (search) {
      url += '&search=' + encodeURIComponent(search);
    }
    for (const [key, value] of Object.entries(filters || {})) {
      if (value !== null && value !== undefined && value !== '') {
        url += `&${key}=${encodeURIComponent(String(value))}`;
      }
    }
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: url,
      Success: (e: any) => {
        this.venueResponseModel.next(e);
        this.parentVenuesComponent.venuessReceived();
        return e;
      },
      Error: (e: any) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  createVenue(data: any, onSuccess?: () => void, onError?: () => void) {
    let str = ApiCollection.venue;
    let d: ApiServiceDelegate = {
      Data: data,
      Method: 'POST',
      Action: str,
      Success: (e: any) => {
        this.message.success('Venue created successfully', {
          nzDuration: 1000,
        });
        if (onSuccess) {
          onSuccess();
        }
        return e;
      },
      Error: (e: String) => {
        this.formatBackendErrors(e);
        if (onError) {
          onError();
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  updateVenue(venueId: number, payload: any) {
    const str = ApiCollection.venue + '/' + venueId;
    // return;
    const d: ApiServiceDelegate = {
      Data: payload,
      Method: 'PATCH',
      Action: str,
      Success: (e: any) => {
        // this.venueDrawerComponent.handleModelClose();
        return e;
      },
      Error: (e: String) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  deleteVenue(id: any, onSuccess?: () => void) {
    let str = ApiCollection.venue + '/' + id;
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'DELETE',
      Action: str,
      Success: (e: any) => {
        this.message.success('Venue deleted successfully', {
          nzDuration: 1000,
        });

        if (onSuccess) {
          onSuccess();
        }

        return e;
      },
      Error: (e: String) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  getVenueV2Detail(id: any, onSuccess?: (venue: any) => void, onError?: (error: any) => void) {
    const d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: `${ApiCollection.venue}/${id}`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  updateVenueV2Information(venueInfoId: any, payload: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) {
    const d: ApiServiceDelegate = {
      Data: payload,
      Method: 'PATCH',
      Action: `${ApiCollection.venue_information}/${venueInfoId}`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  getVenueV2PocList(venueId: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) {
    const d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: `${ApiCollection.venue_poc}?venue=${venueId}&page_size=100`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  deleteVenueV2Poc(id: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) {
    const d: ApiServiceDelegate = {
      Data: {},
      Method: 'DELETE',
      Action: `${ApiCollection.venue_poc}/${id}`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  getVenueV2RoomList(venueId: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) {
    const d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: `${ApiCollection.venue_room}?venue=${venueId}&page_size=100`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  deleteVenueV2Room(id: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) {
    const d: ApiServiceDelegate = {
      Data: {},
      Method: 'DELETE',
      Action: `${ApiCollection.venue_room}/${id}`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  getVenueV2NearbyVenues(venueTypeId: number, onSuccess?: (data: any) => void, onError?: (error: any) => void) {
    const d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: `${ApiCollection.venue}?venue_type=${venueTypeId}&page_size=6`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  uploadVenueV2Image(file: File, userId: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('created_by', String(userId));
    formData.append('modified_by', String(userId));

    return this.apiService
      .execute(formData, `${this.apiService.url}${ApiCollection.Media}`, 'POST')
      .pipe(map((response: any) => response.res));
  }

  updateVenueV2Images(
    venueId: any,
    imageIds: number[],
    onSuccess?: (data: any) => void,
    onError?: (error: any) => void,
    imageOrderIds: number[] = imageIds
  ) {
    const d: ApiServiceDelegate = {
      Data: { images: imageIds, image_order: imageOrderIds },
      Method: 'PATCH',
      Action: `${ApiCollection.venue}/${venueId}`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  deleteVenueV2MediaImage(imageId: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) {
    const d: ApiServiceDelegate = {
      Data: {},
      Method: 'DELETE',
      Action: `${ApiCollection.Media}/${imageId}`,
      Success: (e: any) => {
        if (onSuccess) {
          onSuccess(e);
        }
        return e;
      },
      Error: (e: any) => {
        if (onError) {
          onError(e);
        }
        return e;
      },
    };
    this.apiService.callService(d);
  }

  getVenueV2MediaUrl(image: any): string | null {
    const url = image?.file || image?.url || image?.image || image?.file_url || image?.media_url || image?.path;
    if (!url || typeof url !== 'string') return null;
    if (/^(https?:)?\/\//.test(url) || url.startsWith('data:')) return url;
    if (url.startsWith('/')) return `${this.apiService.url}${url}`;
    return url;
  }

  getCountryCodeList() {
    let src = ApiCollection.Country_Code + '?page=1&page_size=1000';

    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: src,
      Success: (e: any) => {
        this.countryCodeList.next(e);
        return e;
      },
      Error: (e: String) => {
        return e;
      },
    };
    this.apiService.callService(d);
  }

  getVenuePoc(page: number, page_size: number, venue: string) {
    let url =
      ApiCollection.venue_poc + '?page=' + page + '&page_size=' + page_size;
    if (venue) {
      url += '&venue=' + encodeURIComponent(venue);
    }
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: url,
      Success: (e: any) => {
        this.venuePocResponseModel.next(e);
        this.parntVenuesPocComponet.venuesPocRecieved();
        return e;
      },
      Error: (e: any) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  createPOC(data: any) {
    let d: ApiServiceDelegate = {
      Data: data,
      Method: 'POST',
      Action: ApiCollection.venue_poc,
      Success: (e: any) => {
        this.VenueAddPocComponent.pocCreated();
        this.message.success('Vendor POC created successfully', {
          nzDuration: 1000,
        });
        return e;
      },
      Error: (e: any) => {
        this.message.error(String(e), { nzDuration: 1000 });
        return e;
      },
    };
    this.apiService.callService(d);
  }

  updatePOC(data: any, id: number, caller: string, onSuccess?: () => void) {
    let d: ApiServiceDelegate = {
      Data: data,
      Method: 'PATCH',
      Action: ApiCollection.venue_poc + '/' + id,
      Success: (e: any) => {
        if (caller === 'venueAddPocComponent') {
          this.VenueAddPocComponent.pocUpdated();
        }

        this.message.success('Vendor POC updated successfully', {
          nzDuration: 1000,
        });

        if (caller === 'venueDetailComponent') {
          if (onSuccess) {
            onSuccess();
          }
        }

        return e;
      },
      Error: (e: any) => {
        this.message.error(String(e), { nzDuration: 1000 });
        console.log(e);
        return e;
      },
    };

    this.apiService.callService(d);
  }

  deletePOC(id: number, onSuccess?: () => void) {
    let str = ApiCollection.venue_poc + '/' + id;

    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'DELETE',
      Action: str,
      Success: (e: any) => {
        this.message.success('Vendor POC deleted successfully', {
          nzDuration: 1000,
        });

        if (onSuccess) {
          onSuccess();
        }

        return e;
      },
      Error: (e: String) => {
        this.message.error(String(e), { nzDuration: 1000 });
        return e;
      },
    };

    this.apiService.callService(d);
  }

  importVenuesFromCSV(
    formData: FormData,
    onSuccess?: () => void,
    onError?: () => void
  ) {
    const str = ApiCollection.venue_import;

    const d: ApiServiceDelegate = {
      Data: formData,
      Method: 'POST',
      Action: str,
      Success: (e: any) => {
        this.message.success('Venues imported successfully!', {
          nzDuration: 2000,
        });
        if (onSuccess) {
          onSuccess();
        }
        return e;
      },
      Error: (e: any) => {
        const errorMessage =
          e?.error?.detail || 'The server returned an error.';
        this.message.error(`Import failed: ${errorMessage}`, {
          nzDuration: 4000,
        });
        if (onError) {
          onError();
        }
        return e;
      },
    };

    this.apiService.callService(d);
  }

  getVenueRoom(page: number, page_size: number, venue: string) {
    let url =
      ApiCollection.venue_room + '?page=' + page + '&page_size=' + page_size;
    if (venue) {
      url += '&venue=' + encodeURIComponent(venue);
    }
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: url,
      Success: (e: any) => {
        this.venueRoomResponseModel.next(e);
        this.VenueDetailComponent.venuesRoomRecived();
        return e;
      },
      Error: (e: any) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  createRoom(data: any) {
    let d: ApiServiceDelegate = {
      Data: data,
      Method: 'POST',
      Action: ApiCollection.venue_room,
      Success: (e: any) => {
        this.VenueAddRoomComponent.roomCreated();
        this.message.success('Vendor POC created successfully', {
          nzDuration: 1000,
        });
        return e;
      },
      Error: (e: any) => {
        this.message.error(String(e), { nzDuration: 1000 });
        return e;
      },
    };
    this.apiService.callService(d);
  }

  updateRoom(data: any, id: number, caller: string, onSuccess?: () => void) {
    let d: ApiServiceDelegate = {
      Data: data,
      Method: 'PATCH',
      Action: ApiCollection.venue_room + '/' + id,
      Success: (e: any) => {
        if (caller === 'venueAddRoomComponent') {
          this.VenueAddRoomComponent.roomUpdated();
        }

        this.message.success('Vendor POC updated successfully', {
          nzDuration: 1000,
        });

        if (caller === 'venueDetailComponent') {
          if (onSuccess) {
            onSuccess();
          }
        }

        return e;
      },
      Error: (e: any) => {
        this.message.error(String(e), { nzDuration: 1000 });
        console.log(e);
        return e;
      },
    };

    this.apiService.callService(d);
  }

  deleteRoom(id: number, onSuccess?: () => void) {
    let str = ApiCollection.venue_room + '/' + id;

    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'DELETE',
      Action: str,
      Success: (e: any) => {
        this.message.success('Vendor Room deleted successfully', {
          nzDuration: 1000,
        });

        if (onSuccess) {
          onSuccess();
        }

        return e;
      },
      Error: (e: String) => {
        this.message.error(String(e), { nzDuration: 1000 });
        return e;
      },
    };

    this.apiService.callService(d);
  }

  getVenueInformation(page: number, page_size: number, venue: string) {
    // let url =
    //   ApiCollection.venue_information +
    //   '?page=' +
    //   page +
    //   '&page_size=' +
    //   page_size;
    // if (venue) {
    //   url += '&venue=' + encodeURIComponent(venue);
    // }
    // let d: ApiServiceDelegate = {
    //   Data: {},
    //   Method: 'GET',
    //   Action: url,
    //   Success: (e: any) => {
    //     this.venueInformationResponseModel.next(e);
    //     this.VenueDetailComponent.venuesInformationRecived();
    //     return e;
    //   },
    //   Error: (e: any) => {
    //     this.formatBackendErrors(e);
    //     return e;
    //   },
    // };
    // this.apiService.callService(d);
  }

  updatedVenueInformation(venueInfoId:any,payload: any, onSuccess?: () => void) {

    let str = ApiCollection.venue_information;

    // if (payload.venue) {
    //   str += '/' + payload.venue;
    // }

     if (venueInfoId) {
      str += '/' + venueInfoId;
    }

    let d: ApiServiceDelegate = {
      Data: payload,
      Method: 'PATCH',
      Action: str,
      Success: (e: any) => {
        this.message.success('Venue information updated successfully', {
          nzDuration: 1000,
        });

        if (onSuccess) {
          onSuccess();
        }

        return e;
      },
      Error: (e: String) => {
        this.message.error(String(e), { nzDuration: 1000 });
        return e;
      },
    };

    this.apiService.callService(d);
  }

  createVenueRoomLink(data: any) {
    let d: ApiServiceDelegate = {
      Data: data,
      Method: 'POST',
      Action: ApiCollection.Link,
      Success: (e: any) => {
        this.linkResponse.next(e);
        this.message.success('venue media link created successfully', {
          nzDuration: 1000,
        });

        if (data.Success) {
          data.Success(e);
        }
        return e;
      },
      Error: (e: String) => {
        this.message.success(String(e), { nzDuration: 1000 });
        console.log(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  updateVenueRoomLink(payload: any) {
    let url = ApiCollection.Link;
    if (payload.id) {
      url += '/' + payload.id;
    }

    let d: ApiServiceDelegate = {
      Data: payload,
      Method: 'PATCH',
      Action: url,
      Success: (e: any) => {
        this.message.success('Venue media link updated successfully', {
          nzDuration: 1000,
        });

        if (payload.Success) {
          payload.Success(e); // ✅ now callback from child runs
        }
        return e;
      },
      Error: (e: any) => {
        this.message.error(String(e), { nzDuration: 1000 });

        if (payload.Error) {
          payload.Error(e);
        }
        return e;
      },
    };

    this.apiService.callService(d);
  }

  deleteVenueRoomLink(id: number, onSuccess?: () => void, onError?: () => void) {
    let str = ApiCollection.Link + '/' + id;

    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'DELETE',
      Action: str,
      Success: (e: any) => {
        this.message.success('Media link deleted successfully', {
          nzDuration: 1000,
        });

        if (onSuccess) {
          onSuccess();
        }

        return e;
      },
      Error: (e: String) => {
        this.message.error(String(e), { nzDuration: 1000 });
        if (onError) {
          onError();
        }
        return e;
      },
    };

    this.apiService.callService(d);
  }
}
